import { DeleteImportModalComponent } from './../../_modals/delete-import-modal/delete-import-modal/delete-import-modal.component';
import { DataSource } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { PartnerService } from '../../../services/partner.service';
import { ImportService } from '../../../services/import.service';
import { MatPaginator } from '@angular/material/paginator';

import { DataManagementCreateShowModalComponent } from '../../_modals/data-management-create-show-modal/data-management-create-show-modal.component';
import { ShowMapperModalComponent } from '../../_modals/show-mapper-modal/show-mapper-modal.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';


@Component({
  selector: 'app-import-management',
  templateUrl: './import-management.component.html',
  styleUrls: ['./import-management.component.scss'],
})
export class ImportManagementComponent implements OnInit, AfterViewInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  displayedColumns: string[] = [
    'import_pro_mapped_headers_profile',
    'pro_type',
    'pro_year',
    'pro_quarter',
    'status',
    'action'
    // 'artist__user__first_name',
    // 'genre',
    // 'sub_genre',
    // 'created_at',
    // 'updated_at',
    // 'approved_at',
    // 'status',
    // 'action',
  ];

  // tableData: MatTableDataSource<any>;
  
  tableData: MatTableDataSource<any>;
  profileId: any;
  isFetchingTableData = false;

  searchFilterFocused = false;
  searchString: any;

  proShows: any;
  partnerGroups: any;

  constructor(private partnerService: PartnerService, private importService: ImportService,
              private dialog: MatDialog, private route: ActivatedRoute,
              private router: Router,
              ) {
    // hard-coded some imports data for table
  }

  ngOnInit() {

    // set profileID off the URL parameter
    // other importService subscription stuff is here for Robert's pieces until those can be undone
    this.route.queryParams.subscribe(params => {
      this.profileId = params['profileId'];
      console.log('Profile ID:', this.profileId);

      if (this.profileId) {
        this.importService.getImportProMappedHeadersProfile(this.profileId).subscribe((x) => {
          this.importService.setImportProMappedHeadersProfile(x);

          //this needs to be set for the header to display the appropriate buttons
          this.importService.setImportedFilePath(x.filePath);

        })
      }
    });

    // reload table when a modal closes (WITH SUCCESS, not canceled)
    // this.partnerService.modalClosed$.subscribe(() => {
    //   this.isFetchingTableData = true;
    //   this.importService.getImportDetails(this.profileId, 1).subscribe((res: any) => {
    //     this.tableData = new MatTableDataSource<any>(res);
    //     this.tableData.paginator = this.paginator;
    //     this.isFetchingTableData = false;
    //   });
    // });


    // this.isFetchingTableData = true;
    // this.importService.getImportDetails(this.profileId, 1).subscribe( (res: any) => {
    //   this.tableData = new MatTableDataSource<any>(res);
    //   this.tableData.paginator = this.paginator;
    //   this.isFetchingTableData = false;
    // });

    this.partnerService.getAllPROShows().subscribe( (res: any) => {
      this.proShows = res;
    });

    this.partnerService.getPartnerGroups().subscribe((resPartnerGroups: any) => {
      this.partnerGroups = resPartnerGroups;
    });

    this.importService.getImportDetailsList().subscribe((res: any) => {
      this.tableData = new MatTableDataSource<any>(res);
      // this.tableData = new MatTableDataSource<any>(res.sort((a,b) => b.import_pro_mapped_headers_profile - a.import_pro_mapped_headers_profile));
      this.tableData.sort = this.sort;
    });
  }

  ngAfterViewInit() {
  }

  confirmDelete(row: any) {
    let ref = this.dialog.open(DeleteImportModalComponent);

    ref.afterClosed().subscribe((result => {
      if(result) {
        this.importService.deleteImport(row.id).subscribe((res) => {
          console.log(res);
          this.importService.getImportDetailsList().subscribe((res: any) => {
            this.tableData = new MatTableDataSource<any>(res);
            this.tableData.sort = this.sort;
          });
        });
      }
    }))
  }

  getSearchVal(event: any){
    this.searchString = event.trim();
  }

  filterData(search: any) {
    this.tableData.filter = search;
  }

  openCreateShowModal(show: any) {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: show.showName,
      partnerGroups: this.partnerGroups
    };
    this.dialog.open(DataManagementCreateShowModalComponent, dialogConfig);
  }

  openMapShowModal(show: any) {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      // title: show.showName,
      importedProShow: show,
      shows: this.proShows
    };
    this.dialog.open(ShowMapperModalComponent, dialogConfig);
  }

  navigateToMapShowsTable(proImport: any) {
    // uncomment when data comes from server and proper profileIds can be assigned
    const id: string = proImport.import_pro_mapped_headers_profile;
    this.router.navigateByUrl('/data/pro/show-mapper?profileId=' + id);
    //     this.router.navigate(['/data/pro/show-mapper', {
    //   queryParams: { profileId: id }
    // }
    // ]);
  }

  navigateToMapPartnerGroupsTable(proImport: any) {
    // uncomment when data comes from server and proper profileIds can be assigned
    const id: string = proImport.import_pro_mapped_headers_profile;
    this.router.navigateByUrl('/data/pro/partner-group-mapper?profileId=' + id);
  }
}
